<div class="flex-1 min-h-0 flex flex-col bg-[#2a3a6c] overflow-x-hidden min-w-0 w-full">
  <div *ngIf="bannerContent" class="w-full bg-green-600 text-white text-center py-2 flex-shrink-0 min-w-0">
    <div [innerHTML]="bannerContent"></div>
  </div>
  <div class="w-full flex-1 flex flex-col md:flex-row justify-start md:justify-evenly items-stretch gap-0 md:gap-4 bg-[#2a3a6c] py-0 md:py-0 min-h-0 min-w-0 overflow-x-hidden" [class.signup-active]="showSignup">
    <div *ngIf="sessionParam" class="w-full md:w-1/2 flex flex-col flex-shrink-0 justify-start items-center px-4 py-8 md:pt-[5.5rem] md:pb-12 order-first">
      <div class="w-full max-w-md rounded-2xl bg-white/10 backdrop-blur px-6 py-8 md:px-8 md:pt-8 md:pb-10 text-center shadow-lg border border-white/20">
        <p class="text-white text-lg md:text-xl font-medium leading-relaxed">
          Your purchase is confirmed
        </p>
        <p class="text-white/90 text-sm md:text-base mt-4 leading-relaxed">
          If you already have an account, sign in. Otherwise, sign up to complete your registration.
        </p>
      </div>
    </div>
    <div *ngIf="!sessionParam" class="w-full md:w-1/2 flex-shrink-0 car-image-container h-[35vh] min-h-[140px] md:flex-1 md:min-h-0 md:overflow-hidden order-first md:relative">
      <img src="{{'assets/img/banner.png'}}" class="banner-img w-full h-full min-h-0 object-cover object-bottom md:object-center" alt="">
    </div>
    <div class="w-full md:w-1/2 flex flex-col flex-shrink-0 items-center justify-start md:justify-start pt-4 md:pt-0 order-last md:order-none">
      <div class="w-full flex justify-center overflow-x-hidden">
        <div class="w-full max-w-full md:max-w-md bg-[#2a3a6c] rounded-none md:rounded-xl px-4 py-4 md:p-8 flex flex-col justify-start md:justify-start">
          <app-signin *ngIf="!showSignup" [sessionParam]="sessionParam" (triggerSignup)="showSignup = true"></app-signin>
          <app-signup *ngIf="showSignup" [sessionParam]="sessionParam" (triggerSignin)="showSignup = false"></app-signup>
        </div>
      </div>
    </div>
  </div>  
</div>


<!-- </main> -->
